module.exports = __webpack_public_path__ + "static/media/No_services.5d029911.svg";